import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:62
* @route '/app/creator/setup/profile'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/setup/profile',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:62
* @route '/app/creator/setup/profile'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:62
* @route '/app/creator/setup/profile'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:62
* @route '/app/creator/setup/profile'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:62
* @route '/app/creator/setup/profile'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const profile = {
    store: Object.assign(store, store),
}

export default profile